export enum UserTier {
  Public = 'Public',
  Expired = 'Expired',
  Trial = 'Trial',
  Basic = 'Basic',
  PremiumNoApi = 'PremiumNoApi',
  Premium = 'Premium'
}

export enum Permission {
  // Market / navigation — Trial and above
  ViewMarketScreens = 'view-market-screens', // also gates Catalog lock icon

  //Catalog
  ViewCatalogDetails = 'view-catalog-details',

  // IndexInformation
  ViewIndexInformationBasic = 'view-index-information-basic',
  ViewIndexInformationExtendedInfo = 'view-index-information-extended-info',
  ViewIndexInformationChart = 'view-index-information-chart',

  // Charts
  ViewChartInFullscreen = 'view-chart-in-fullscreen',
  UseSmallChartWatermark = 'use-small-chart-watermark', // absence = large watermark

  // Export
  ExportView = 'export-view',
  ExportImage = 'export-image',
  ExportBasic = 'export-basic',
  ExportViaApi = 'export-via-api',
  ViewPastExports = 'view-past-exports',
  ExportDataChartPreview = 'export-data-chart-preview',

  // Dashboard
  DashboardPremiumWidgets = 'dashboard-premium-widgets',

  // Api Token
  GenerateApiToken = 'generate-api-token'
}
